import { render } from "./BehaviouralModelLineageTable.vue?vue&type=template&id=0716e57d&ts=true"
import script from "./BehaviouralModelLineageTable.vue?vue&type=script&lang=ts"
export * from "./BehaviouralModelLineageTable.vue?vue&type=script&lang=ts"

import "./BehaviouralModelLineageTable.vue?vue&type=style&index=0&id=0716e57d&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__